import { render, staticRenderFns } from "./CategoriesFormPage.vue?vue&type=template&id=cbdf9394&"
import script from "./CategoriesFormPage.vue?vue&type=script&lang=js&"
export * from "./CategoriesFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports